export const IS_DESKTOP = getWidth() > 600


export function getHeight(): number {
  return window.innerHeight
}


export function getWidth(): number {
  return window.innerWidth
}


// WEBPACK FOOTER //
// ./src/service/device.ts